/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';

function ElectivePool({ adminToken, onBack }) {
    const navigate = useNavigate();
    const [viewMode, setViewMode] = useState('programs'); // 'programs' | 'courses'
    const [programs, setPrograms] = useState([]);
    const [selectedProgram, setSelectedProgram] = useState(null);
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState('');

    // State for Linking
    const [selectedLessonIds, setSelectedLessonIds] = useState([]);
    const [programGroups, setProgramGroups] = useState([]);
    const [showLinkModal, setShowLinkModal] = useState(false);
    const [selectedGroupId, setSelectedGroupId] = useState('');

    // State for Groups Modal
    const [showGroupsModal, setShowGroupsModal] = useState(false);
    const [expandedPoolId, setExpandedPoolId] = useState(null);

    useEffect(() => {
        fetchPrograms();
    }, []);

    const fetchPrograms = async () => {
        // ... (unchanged)

        try {
            setLoading(true);
            const res = await fetch(`${API_BASE_URL}/api/programs`, {
                headers: { Authorization: `Bearer ${adminToken}` }
            });
            if (res.ok) {
                const data = await res.json();
                setPrograms(data.sort((a, b) => a.name.localeCompare(b.name, 'tr')));
            } else {
                console.error('Failed to fetch programs');
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleProgramSelect = async (program) => {
        setSelectedProgram(program);
        setViewMode('courses');
        setLoading(true);
        // Fetch Elective Lessons
        try {
            await fetchElectives(program.id);
        } catch (err) { console.error(err); }

        // Fetch Existing Groups (Courses) for this program to facilitate linking
        fetchProgramGroups(program.id);

        setLoading(false);
    };

    const fetchElectives = async (programId) => {
        const res = await fetch(`${API_BASE_URL}/api/admin/elective-courses?program_id=${programId}`, {
            headers: { Authorization: `Bearer ${adminToken}` }
        });
        if (res.ok) {
            const data = await res.json();
            setCourses(data);
        }
    };

    const fetchProgramGroups = async (programId) => {
        try {
            const res = await fetch(`${API_BASE_URL}/api/programs/${programId}/courses`, {
                headers: { Authorization: `Bearer ${adminToken}` }
            });
            if (res.ok) {
                const data = await res.json();
                // Filter mostly 'Seçmeli' types
                setProgramGroups(data.filter(c => c.course_type.toLowerCase().includes('seçmeli')));
            }
        } catch (err) { console.error(err); }
    };

    const handlePromoteToGroup = async () => {
        if (selectedLessonIds.length !== 1) return;

        const lessonId = selectedLessonIds[0];
        const course = courses.find(c => c.id === lessonId);
        if (!course) return;

        if (!window.confirm(`"${course.course_name}" dersini ANA DERS (Havuz) yapmak istiyor musunuz? Bu işlem dersi seçmeli listesinden kaldırıp müfredata ekleyecektir.`)) return;

        try {
            setLoading(true);
            const res = await fetch(`${API_BASE_URL}/api/programs/${selectedProgram.id}/elective-lessons/${lessonId}/promote-to-group`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${adminToken}`
                }
            });

            if (res.ok) {
                alert('Ders başarıyla havuza dönüştürüldü!');
                setSelectedLessonIds([]);
                await fetchElectives(selectedProgram.id);
                await fetchProgramGroups(selectedProgram.id);
            } else {
                const d = await res.json();
                alert(d.error || 'Hata oluştu');
            }
        } catch (err) {
            alert('Hata: ' + err);
        } finally {
            setLoading(false);
        }
    };

    const handleUnlinkLesson = async (lessonId) => {
        try {
            setLoading(true);
            const res = await fetch(`${API_BASE_URL}/api/programs/${selectedProgram.id}/elective-lessons/${lessonId}/unlink`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${adminToken}`
                }
            });

            if (res.ok) {
                // Refresh data
                await fetchElectives(selectedProgram.id);
            } else {
                alert('Hata oluştu');
            }
        } catch (err) {
            console.error(err);
            alert('Hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    const handleLinkLessons = async () => {
        if (!selectedGroupId || selectedLessonIds.length === 0) return;

        try {
            setLoading(true);
            const res = await fetch(`${API_BASE_URL}/api/programs/${selectedProgram.id}/elective-groups/${selectedGroupId}/link-lessons`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${adminToken}`
                },
                body: JSON.stringify({ lesson_ids: selectedLessonIds })
            });

            if (res.ok) {
                alert('Dersler başarıyla bağlandı!');
                setShowLinkModal(false);
                setSelectedLessonIds([]);
                await fetchElectives(selectedProgram.id);

            } else {
                alert('Hata oluştu');
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const filteredPrograms = programs.filter(p =>
        p.name.toLowerCase().replace(/i/g, 'İ').includes(filter.toLocaleLowerCase('tr')) ||
        p.name.toLowerCase().includes(filter.toLowerCase())
    );

    const filteredCourses = courses.filter(c =>
        (c.course_name || '').toLowerCase().includes(filter.toLowerCase()) ||
        (c.course_code || '').toLowerCase().includes(filter.toLowerCase())
    );

    return (
        <div className="App">
            <div className="header">
                <div className="header-content">
                    <div className="header-left">
                        <div className="logo" onClick={() => navigate('/admin')} style={{ cursor: 'pointer' }}>
                            <img src="/kostu_logo.png" alt="Logo" className="logo-image" />
                            <span className="logo-text">KOSTÜ - Seçmeli Ders Havuzu</span>
                        </div>
                    </div>
                    <div className="header-right">
                        <button onClick={() => navigate('/admin')} className="logout-button">Admin Paneli</button>
                    </div>
                </div>
            </div>

            <div className="main-content" style={{ padding: '20px' }}>
                <div style={{ maxWidth: 1200, margin: '0 auto', background: 'white', padding: 20, borderRadius: 8, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <button
                                onClick={() => {
                                    if (viewMode === 'courses') {
                                        setViewMode('programs');
                                        setSelectedProgram(null);
                                        setFilter('');
                                    } else {
                                        navigate('/admin');
                                    }
                                }}
                                style={{
                                    padding: '8px 14px',
                                    borderRadius: 6,
                                    border: '1px solid #9ca3af',
                                    background: '#6b7280',
                                    color: '#ffffff',
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    transition: 'background 0.15s ease'
                                }}
                                onMouseEnter={(e) => { e.currentTarget.style.background = '#4b5563'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.background = '#6b7280'; }}
                            >
                                ← Geri
                            </button>
                            <h2 style={{ margin: 0 }}>
                                {viewMode === 'programs' ? 'Program Seçimi' : `${selectedProgram?.name} - Seçmeli Dersler`}
                            </h2>
                        </div>

                        <input
                            type="text"
                            placeholder={viewMode === 'programs' ? "Program Ara..." : "Ders Ara..."}
                            value={filter}
                            onChange={(e) => setFilter(e.target.value)}
                            style={{ padding: '8px 12px', border: '1px solid #ddd', borderRadius: 4, width: 300 }}
                        />
                    </div>

                    {viewMode === 'courses' && (
                        <div style={{ marginBottom: 16, display: 'flex', gap: 10 }}>
                            <button
                                onClick={() => setShowGroupsModal(true)}
                                style={{
                                    background: '#e5e7eb',
                                    color: '#374151',
                                    border: '1px solid #d1d5db',
                                    padding: '10px 16px',
                                    borderRadius: 6,
                                    cursor: 'pointer',
                                    fontWeight: 500
                                }}
                            >
                                Seçmeli Havuzları ({programGroups.length})
                            </button>

                            <button
                                onClick={handlePromoteToGroup}
                                disabled={selectedLessonIds.length !== 1}
                                style={{
                                    background: selectedLessonIds.length === 1 ? '#8b5cf6' : '#d1d5db',
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 16px',
                                    borderRadius: 6,
                                    cursor: selectedLessonIds.length === 1 ? 'pointer' : 'not-allowed',
                                    fontWeight: 500
                                }}
                            >
                                Seçileni Havuz (Ana Ders) Yap
                            </button>

                            <button
                                onClick={() => setShowLinkModal(true)}
                                disabled={selectedLessonIds.length === 0}
                                style={{
                                    background: selectedLessonIds.length > 0 ? '#3b82f6' : '#d1d5db',
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 16px',
                                    borderRadius: 6,
                                    cursor: selectedLessonIds.length > 0 ? 'pointer' : 'not-allowed',
                                    fontWeight: 500
                                }}
                            >
                                Seçilenleri Gruba Bağla ({selectedLessonIds.length})
                            </button>
                        </div>
                    )}

                    {loading ? (
                        <div>Yükleniyor...</div>
                    ) : viewMode === 'programs' ? (
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
                            {filteredPrograms.map(program => (
                                <div
                                    key={program.id}
                                    onClick={() => handleProgramSelect(program)}
                                    style={{
                                        padding: 20,
                                        border: '1px solid #e5e7eb',
                                        borderRadius: 8,
                                        cursor: 'pointer',
                                        transition: 'all 0.2s',
                                        background: '#fff'
                                    }}
                                    onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#10b981'; e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#e5e7eb'; e.currentTarget.style.boxShadow = 'none'; }}
                                >
                                    <div style={{ fontWeight: 600, color: '#111827', marginBottom: 4 }}>{program.name}</div>
                                    <div style={{ fontSize: 13, color: '#6b7280' }}>Bölüm Kodu: {program.program_code || '-'}</div>
                                </div>
                            ))}
                            {filteredPrograms.length === 0 && (
                                <div style={{ gridColumn: '1/-1', textAlign: 'center', color: '#6b7280', padding: 20 }}>
                                    Program bulunamadı.
                                </div>
                            )}
                        </div>
                    ) : (
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ background: '#f9fafb', borderBottom: '2px solid #e5e7eb' }}>
                                        <th style={{ padding: 12, width: 40, textAlign: 'center' }}>
                                            <input type="checkbox" onChange={(e) => {
                                                if (e.target.checked) setSelectedLessonIds(filteredCourses.map(c => c.id));
                                                else setSelectedLessonIds([]);
                                            }} checked={filteredCourses.length > 0 && selectedLessonIds.length === filteredCourses.length} />
                                        </th>
                                        <th style={{ padding: 12, textAlign: 'left' }}>Kod</th>
                                        <th style={{ padding: 12, textAlign: 'left' }}>Ad</th>
                                        <th style={{ padding: 12, textAlign: 'left' }}>Tip</th>
                                        <th style={{ padding: 12, textAlign: 'left' }}>Bağlı Olduğu Havuz</th>
                                        <th style={{ padding: 12, textAlign: 'center' }}>T</th>
                                        <th style={{ padding: 12, textAlign: 'center' }}>U</th>
                                        <th style={{ padding: 12, textAlign: 'center' }}>L</th>
                                        <th style={{ padding: 12, textAlign: 'center' }}>Kredi</th>
                                        <th style={{ padding: 12, textAlign: 'center' }}>AKTS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredCourses.length > 0 ? (
                                        filteredCourses.map(course => (
                                            <tr key={course.id} style={{ borderBottom: '1px solid #e5e7eb', background: selectedLessonIds.includes(course.id) ? '#eff6ff' : 'transparent' }}>
                                                <td style={{ padding: 12, textAlign: 'center' }}>
                                                    <input type="checkbox" checked={selectedLessonIds.includes(course.id)} onChange={(e) => {
                                                        if (e.target.checked) setSelectedLessonIds([...selectedLessonIds, course.id]);
                                                        else setSelectedLessonIds(selectedLessonIds.filter(id => id !== course.id));
                                                    }} />
                                                </td>
                                                <td style={{ padding: 12, fontWeight: 500 }}>{course.course_code}</td>
                                                <td style={{ padding: 12 }}>{course.course_name}</td>
                                                <td style={{ padding: 12 }}>{course.course_type}</td>
                                                <td style={{ padding: 12, color: course.course_id ? '#2563eb' : '#9ca3af' }}>
                                                    {course.course_id ? (programGroups.find(g => g.id === course.course_id)?.course_name || `Grup #${course.course_id}`) : '-'}
                                                </td>
                                                <td style={{ padding: 12, textAlign: 'center' }}>{course.teorik}</td>
                                                <td style={{ padding: 12, textAlign: 'center' }}>{course.uygulama}</td>
                                                <td style={{ padding: 12, textAlign: 'center' }}>{course.laboratuvar}</td>
                                                <td style={{ padding: 12, textAlign: 'center' }}>{course.kredi}</td>
                                                <td style={{ padding: 12, textAlign: 'center' }}>{course.akts}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" style={{ padding: 20, textAlign: 'center', color: '#666' }}>Ders bulunamadı.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>

            {/* Groups List Modal */}
            {showGroupsModal && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
                    <div style={{ background: 'white', padding: 24, borderRadius: 8, width: 800, maxWidth: '90%', maxHeight: '80vh', overflowY: 'auto' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                            <h3 style={{ margin: 0 }}>Oluşturulan Seçmeli Havuzlar ({programGroups.length})</h3>
                            <button onClick={() => setShowGroupsModal(false)} style={{ border: 'none', background: 'transparent', fontSize: 20, cursor: 'pointer' }}>×</button>
                        </div>

                        {programGroups.length > 0 ? (
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ background: '#f9fafb', borderBottom: '2px solid #e5e7eb' }}>
                                        <th style={{ padding: 10, textAlign: 'left' }}>Dönem</th>
                                        <th style={{ padding: 10, textAlign: 'left' }}>Kod</th>
                                        <th style={{ padding: 10, textAlign: 'left' }}>Ad</th>
                                        <th style={{ padding: 10, textAlign: 'center' }}>T</th>
                                        <th style={{ padding: 10, textAlign: 'center' }}>U</th>
                                        <th style={{ padding: 10, textAlign: 'center' }}>L</th>
                                        <th style={{ padding: 10, textAlign: 'center' }}>K</th>
                                        <th style={{ padding: 10, textAlign: 'center' }}>A</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {programGroups.sort((a, b) => a.donem - b.donem).map(g => {
                                        const linkedLessons = courses.filter(c => c.course_id === g.id);
                                        const isExpanded = expandedPoolId === g.id;

                                        return (
                                            <React.Fragment key={g.id}>
                                                <tr
                                                    onClick={() => setExpandedPoolId(isExpanded ? null : g.id)}
                                                    style={{
                                                        borderBottom: isExpanded ? 'none' : '1px solid #e5e7eb',
                                                        cursor: 'pointer',
                                                        background: isExpanded ? '#f3f4f6' : 'transparent',
                                                        transition: 'background 0.2s'
                                                    }}
                                                >
                                                    <td style={{ padding: 10 }}>{g.donem}. Dönem {isExpanded ? '▼' : '▶'}</td>
                                                    <td style={{ padding: 10, fontWeight: 500 }}>{g.course_code}</td>
                                                    <td style={{ padding: 10 }}>{g.course_name} <span style={{ fontSize: 12, color: '#666' }}>({linkedLessons.length} ders)</span></td>
                                                    <td style={{ padding: 10, textAlign: 'center' }}>{g.teorik}</td>
                                                    <td style={{ padding: 10, textAlign: 'center' }}>{g.uygulama}</td>
                                                    <td style={{ padding: 10, textAlign: 'center' }}>{g.laboratuvar}</td>
                                                    <td style={{ padding: 10, textAlign: 'center' }}>{g.kredi}</td>
                                                    <td style={{ padding: 10, textAlign: 'center' }}>{g.akts}</td>
                                                </tr>
                                                {isExpanded && (
                                                    <tr style={{ borderBottom: '1px solid #e5e7eb', background: '#f9fafb' }}>
                                                        <td colSpan="8" style={{ padding: '0 0 10px 0' }}>
                                                            <div style={{ padding: '10px 20px', borderTop: '1px dashed #ddd' }}>
                                                                <h4 style={{ margin: '0 0 10px 0', fontSize: 14, color: '#4b5563' }}>Bu Havuza Bağlı Dersler:</h4>
                                                                {linkedLessons.length > 0 ? (
                                                                    <ul style={{ margin: 0, paddingLeft: 20, fontSize: 13 }}>
                                                                        {linkedLessons.map(l => (
                                                                            <li key={l.id} style={{ marginBottom: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: 20 }}>
                                                                                <span><strong>{l.course_code}</strong> - {l.course_name}</span>
                                                                                <button
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        if (window.confirm('Bu dersi havuzdan çıkarmak istediğinize emin misiniz?')) {
                                                                                            handleUnlinkLesson(l.id);
                                                                                        }
                                                                                    }}
                                                                                    style={{
                                                                                        background: '#fee2e2',
                                                                                        color: '#b91c1c',
                                                                                        border: '1px solid #fca5a5',
                                                                                        borderRadius: 4,
                                                                                        padding: '2px 8px',
                                                                                        fontSize: 11,
                                                                                        cursor: 'pointer'
                                                                                    }}
                                                                                >
                                                                                    Listeden Sil
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                ) : (
                                                                    <div style={{ fontStyle: 'italic', color: '#9ca3af', fontSize: 13 }}>Henüz ders bağlanmamış.</div>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                </tbody>
                            </table>
                        ) : (
                            <div style={{ padding: 20, textAlign: 'center', color: '#666', background: '#f9fafb', borderRadius: 4 }}>
                                Henüz seçmeli havuz (ana ders) oluşturulmamış.
                            </div>
                        )}

                        <div style={{ marginTop: 20, textAlign: 'right' }}>
                            <button onClick={() => setShowGroupsModal(false)} style={{ padding: '8px 16px', border: '1px solid #ddd', background: 'white', borderRadius: 4, cursor: 'pointer' }}>Kapat</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Link Modal */}
            {showLinkModal && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
                    <div style={{ background: 'white', padding: 24, borderRadius: 8, width: 400, maxWidth: '90%' }}>
                        <h3 style={{ marginTop: 0 }}>Seçilen Dersleri Gruba Bağla</h3>
                        <p style={{ color: '#666', fontSize: 14 }}>Seçilen {selectedLessonIds.length} dersi aşağıdaki havuza bağla:</p>

                        <select
                            value={selectedGroupId}
                            onChange={e => setSelectedGroupId(e.target.value)}
                            style={{ width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ddd', marginBottom: 20 }}
                        >
                            <option value="">-- Havuz Seçin --</option>
                            {programGroups.map(g => (
                                <option key={g.id} value={g.id}>
                                    {g.course_code} - {g.course_name} ({g.donem}. Dönem)
                                </option>
                            ))}
                        </select>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                            <button type="button" onClick={() => setShowLinkModal(false)} style={{ padding: '8px 16px', border: '1px solid #ddd', background: 'white', borderRadius: 4, cursor: 'pointer' }}>İptal</button>
                            <button type="button" onClick={handleLinkLessons} disabled={!selectedGroupId} style={{ padding: '8px 16px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', opacity: !selectedGroupId ? 0.6 : 1 }}>Bağla</button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}

export default ElectivePool;
